export * from "./password-change-successful-card";
export * from "./password-change-successful-card.types";
